export class Patgruppe {
    static readonly EXTERN = 1;
    static readonly MUW_MITARBEITER = 2;
    static readonly HCW_MUW = 3;
    static readonly MUW_ANGEHOERIGE = 4;
    static readonly MEDIZINSTUDENT = 5;
    static readonly HCW_STUDENT = 6;

    static values(): number[] {
        return Object.values(this);
    }
}
